import React from "react";
import { motion } from "framer-motion";
import Footer from "../components/Footer";

// --- PARTNER LOGO DATA (Includes website links) ---
const partnerLogos = [
  // {
  //   name: "Zscaler",
  //   url: "https://upload.wikimedia.org/wikipedia/commons/2/29/Zscaler_logo.png",
  //   website: "https://www.zscaler.com/",
  // },
  {
    name: "Netskope",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1783241811/netscope_ngqtlr.avif",
    website: "https://www.netskope.com",
  },
  {
    name: " Cato Networks",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1783241811/cato_k6byr3.png",
    website: "https://www.catonetworks.com/",
  },
  {
    name: " Menlo Security",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772882987/Screenshot_2026-03-07_165915_nqndwj.png",
    website: "https://www.menlosecurity.com/",
  },

  {
    name: "Varonis",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179263/Varonis-Logo_381x275_xq5wz5.png",
    website: "https://www.varonis.com/",
  },

  {
    name: "Cyera",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772890856/Screenshot_2026-03-07_191019_lx3kiv.png",
    website: "https://www.cyera.com/",
  },
  // {
  //   name: "BigID",
  //   url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772890987/BigID-next-1_mw5nco.png",
  //   website: "https://bigid.com/",
  // },
  {
    name: "CrowdStrike",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1783241811/crowdstrike_fbisbj.avif",
    website: "https://www.crowdstrike.com",
  },

  // {
  //   name: "sentinelOne",
  //   url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772891298/header-logo-dark_wkcwyr.svg",
  //   website: "https://www.sentinelone.com/",
  // },
  {
    name: "CyberArk",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772891367/cyberark-logo-tagline_s8qu88.svg",
    website: "https://www.cyberark.com/",
  },
  // {
  //   name: "SailPoint",
  //   url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772891462/SailPoint-logo-cropped_ixetqw.svg",
  //   website: "https://www.sailpoint.com/",
  // },
  {
    name: "saviynt",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772891522/saviynt-logo-DWEmNKg8_e5nmpn.svg",
    website: "https://saviynt.com/",
  },
  {
    name: "proofpoint",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772891642/header-nav__logo_lckun2.svg",
    website: "https://www.proofpoint.com/us",
  },

  {
    name: "Abnormal Security",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179263/abnormal-logo-png_seeklogo-442229_c4zwti.png",
    website: "https://abnormal.ai/",
  },
  // {
  //   name: "Mimecast",
  //   url: "https://cdn.prod.website-files.com/65b8bf4128bf6ef762cf3954/68808230283150624a88d443_mimecast.svg",
  //   website: "https://www.mimecast.com",
  // },
  //newly added from slider
  {
    name: "Datadog",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1783241811/datadogs_vpm593.avif",
    website: "https://www.datadoghq.com",
  },
  {
    name: "Dynatrace",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179263/dynatrace_web_logo_mteouk.png",
    website: "https://www.dynatrace.com/",
  },
  {
    name: "Operant",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773052412/operant_fh5odi.svg",
    website: "https://www.operant.ai/",
  },
  {
    name: "Lakera",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179263/lakera_apskuj.png",
    website: "https://www.lakera.ai/",
  },

  {
    name: "Wiz",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773052412/wiz_wg40wv.png",
    website: "https://www.wiz.io/",
  },
  {
    name: "veeam",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773052412/veeam_di40mp.png",
    website: "https://www.veeam.com/",
  },
  // {
  //   name: "Cranium",
  //   url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773123731/cranium_ai_cpa824.png",
  //   website: "https://cranium.ai/",
  // },
  {
    name: "holisticAI",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773123824/hoslistic_msjudy.png",
    website: "https://www.holisticai.com/",
  },
  // {
  //   name: "OneTrust",
  //   url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773123972/One_truatT-website-logo_dkdtmg.svg",
  //   website: "https://www.onetrust.com/",
  // },
  // {
  //   name: "credoAI",
  //   url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773124078/credo_taqfhj.png",
  //   website: "https://www.credo.ai/",
  // },
  // {
  //   name: "Palo Alto Networks",
  //   url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773124092/palo_alto_gtdg10.png",
  //   website: "https://www.paloaltonetworks.in/",
  // },
  // {
  //   name: "securiti.ai",
  //   url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773124229/securitiii2026-03-10_115944_i4tgn2.png",
  //   website: "https://securiti.ai/",
  // },
  // {
  //   name: "Microsoft Security",
  //   url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773124240/micros_t0wbzz.png",
  //   website: "https://www.microsoft.com/en-in/security",
  // },
  {
    name: "zenity",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179263/Zenity-Logo_jywy90.png",
    website: "https://zenity.io/",
  },

  // {
  //   name: "Datadog",
  //   url: "https://cdn.prod.website-files.com/65b8bf4128bf6ef762cf3954/6854f6ca774dd90859ee0a4d_5%20Datadog.avif",
  //   website: "https://www.datadoghq.com",
  // },

  // {
  //   name: "Rubrik",
  //   url: "https://cdn.prod.website-files.com/65b8bf4128bf6ef762cf3954/6854f71705c77581351d9386_14%20Rubrik.avif",
  //   website: "https://www.rubrik.com",
  // },
  // {
  //   name: "ExtraHop",
  //   url: "https://cdn.prod.website-files.com/65b8bf4128bf6ef762cf3954/6880838c5e9c849f57ecf355_ExtraHop.svg",
  //   website: "https://www.extrahop.com",
  // },
  {
    name: "Pentera",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776352940/pentera-logo-black_rzwqt8.svg",
    website: "https://pentera.io/",
  },
  {
    name: "Vanta",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776352939/vanta-logo_uljhws.svg",
    website: "https://www.vanta.com/",
  },
  {
    name: "Connectwise",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776352939/connectbg-cw-black_igvnag.webp",
    website: "https://www.connectwise.com/",
  },
  {
    name: "Akamai Guardicore",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1777958225/akamai-logo-v5_y6r5yy.svg",
    website: "https://www.akamai.com/",
  },
  // {
  //   name: "Langchain",
  //   url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179262/langchain-1_v7dqjm.svg",
  //   website: "https://www.langchain.com/",
  // },
  {
    name: "Group IB",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1781706273/Group-IB_logo_ecdxu6.png",
    website: "https://www.group-ib.com/",
  },

  {
    name: "Vectra AI",
    url: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179262/vectra-ai-platform_xpojll.png",
    website: "https://www.vectra.ai/",
  },
];

export default function PartnersPage() {
  return (
    <div className="bg-white min-h-screen font-sans">
      {/* ================= 1. HERO SECTION (Cityscape Background) ================= */}
      <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 hover:scale-105"
          style={{
            backgroundImage: `url('https://res.cloudinary.com/dpn3bkjba/image/upload/v1783241812/background_parthner_page_h5yifc.avif')`,
          }}
        >
          {/* Dark overlay to ensure text readability and match internalpage.jpg */}
          <div className="absolute inset-0 bg-black/45" />
        </div>

        <div className="relative z-10 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-white text-5xl md:text-7xl font-bold tracking-tight uppercase"
          >
            Our Partners
          </motion.h1>
        </div>
      </section>

      {/* ================= 2. PARTNERS GRID (Overlapping White Section) ================= */}
      <section className="relative z-20 px-6">
        <div className="max-w-7xl mx-auto bg-white rounded-t-[4rem] -mt-24 pt-24 pb-40 shadow-[0_-30px_60px_rgba(0,0,0,0.12)]">
          <div className="text-center mb-20 px-6">
            <h2 className="text-[#032d28] text-3xl md:text-4xl font-black uppercase tracking-tight mb-4">
              Trusted Technology Ecosystem
            </h2>
            <div className="w-24 h-1 bg-[#24ff81] mx-auto mb-6" />
            <p className="text-slate-500 max-w-2xl mx-auto text-lg font-medium leading-relaxed">
              We collaborate with global innovation leaders to deliver
              integrated, automated, and comprehensive security outcomes for our
              clients.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-12 gap-y-20 items-center px-10 md:px-20">
            {partnerLogos.map((logo, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: (index % 6) * 0.05 }}
                whileHover={{ scale: 1.1 }}
                className="flex items-center justify-center p-2 group"
              >
                {/* Wrapped the image in an anchor tag for clickability */}
                <a
                  href={logo.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  {/* UPDATED IMG TAG: Removed grayscale and opacity classes so they are colored by default */}
                  <img
                    src={logo.url}
                    alt={`${logo.name} logo`}
                    className="max-h-12 w-auto object-contain transition-all duration-500 cursor-pointer"
                  />
                </a>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= 3. CALL TO ACTION (Strategic Value) ================= */}
      <section className="py-24 bg-slate-50 border-t border-slate-100">
        <div className="container mx-auto px-6 text-center">
          <h3 className="text-[#032d28] text-2xl md:text-3xl font-bold mb-6">
            Strong Partnerships,{" "}
            <span className="text-[#065c41]">Stronger Defense.</span>
          </h3>
          <p className="text-slate-500 max-w-xl mx-auto font-medium">
            Our deep technical integrations enable proactive incident response
            and unified visibility across your entire security stack.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
